/**
 * Decide if a content blocker can be unblocked.
 */
export var DECIDE_TO_UNBLOCK_CONTENT_BLOCKER_EVENT = "RCB/ContentBlocker/DecideUnblock";